import {HostBinding} from '@angular/core';

export class IconBaseComponent {
  // default class for icon
  @HostBinding('class.ts-icon') class = true;
}
